import React from "react";
import * as Sentry from "@sentry/react";
import { hotjar } from 'react-hotjar';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

function createUrlRegex(startString?: string) {
  if (!startString)
    return undefined
  const escapedString = startString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return [new RegExp(`^${escapedString}\\S+$`)];
}

if (process.env.REACT_APP_ENVIRONMENT !== 'development') {

  // const siteId = 5098002;
  // const hotjarVersion = 6;
  // hotjar.initialize({ id: siteId, sv: hotjarVersion })

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [
      // See docs for support of different versions of variation of react router
      // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        // Bodies are NOT captured. `networkDetailAllowUrls` reads like an
        // allowlist that scopes capture to one API; measured against the
        // deployed prod bundle it scopes nothing. REACT_APP_API_URL is
        // "https://api.bespokecast.ai" there, `createUrlRegex` turns that into
        // ^https:\/\/api\.bespokecast\.ai\S+$, and BOTH API layers build their
        // URLs from exactly that base — `api.ts` as `${API_URL}${urlPath}`, and
        // RestaurantBackend.ts as https:// + restaurantBackendHost. So every
        // call matched, which put shift transcripts (customer speech, via
        // ShiftTranscriptView's apiCall) and crew rosters into session replay
        // at 10% of sessions / 100% of error sessions, with maskAllText: false.
        //
        // DOM masking does not touch this channel, so per-element masking is
        // not a mitigation for it.
        //
        // THIS LINE IS LOAD-BEARING — DO NOT DELETE IT AS REDUNDANT. The option
        // DEFAULTS TO TRUE (@sentry-internal/replay types/replay.d.ts:64), so
        // removing it re-enables body capture rather than leaving it off.
        //
        // Do NOT "fix" this by setting REACT_APP_API_URL to the bare host: the
        // bare form fails the regex, but it also breaks every legacy API call,
        // because api.ts uses the value as a URL base and would emit paths with
        // no scheme or host. The capture switch is the control; the env var is
        // load-bearing for something else.
        networkCaptureBodies: false,
        networkDetailAllowUrls: createUrlRegex(process.env.REACT_APP_API_URL),
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    tracesSampleRate: 1.0,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
